export default __webpack_public_path__ + "static/media/gold_outlined.741ad030.svg";